// State management for pull-to-load functionality

let pullToLoadState = {
    isActive: false,
    startY: 0,
    currentY: 0,
    pullDistance: 0,
    isLoading: false,
    currentPage: 1,
    totalPages: 1,
    query: '',
    justFinishedLoading: false // Flag to prevent text flickering after page load
};

let pullIndicator = null;
let animationFrameId = null;
let targetDistance = 0; // Target distance for smooth interpolation
let currentDisplayDistance = 0; // Current displayed distance (for smooth animation)
let immediateTranslateYDistance = 0; // Immediate distance for translateY (no interpolation)

export function getPullToLoadState() {
    return pullToLoadState;
}

export function setPullToLoadState(updates) {
    Object.assign(pullToLoadState, updates);
}

export function getPullIndicator() {
    return pullIndicator;
}

export function setPullIndicator(indicator) {
    pullIndicator = indicator;
}

export function getAnimationFrameId() {
    return animationFrameId;
}

export function setAnimationFrameId(id) {
    animationFrameId = id;
}

export function getTargetDistance() {
    return targetDistance;
}

export function setTargetDistance(distance) {
    targetDistance = distance;
}

export function getCurrentDisplayDistance() {
    return currentDisplayDistance;
}

export function setCurrentDisplayDistance(distance) {
    currentDisplayDistance = distance;
}

export function getImmediateTranslateYDistance() {
    return immediateTranslateYDistance;
}

export function setImmediateTranslateYDistance(distance) {
    immediateTranslateYDistance = distance;
}

